import { useEffect, useState } from 'react';
import { THEME_CLEARED_EVENT, THEME_LOADED_EVENT } from './types';
export const usePersonalizationTheme = () => {
    const [theme, setTheme] = useState(null);
    useEffect(() => {
        const handleThemeLoaded = (event) => {
            const customEvent = event;
            setTheme(customEvent.detail ?? null);
        };
        const handleThemeCleared = () => {
            setTheme(null);
        };
        window.addEventListener(THEME_LOADED_EVENT, handleThemeLoaded);
        window.addEventListener(THEME_CLEARED_EVENT, handleThemeCleared);
        return () => {
            window.removeEventListener(THEME_LOADED_EVENT, handleThemeLoaded);
            window.removeEventListener(THEME_CLEARED_EVENT, handleThemeCleared);
        };
    }, []);
    const hasTheme = !!(theme?.headerImage || theme?.headerLine1);
    return { theme, hasTheme };
};
